import { request, authRequest } from "~/utils/api";
import {
  openRequest,
  closeRequest,
  showAppMessage,
  fireEvent,
} from "~/redux/actions/app";

export const CREATE_COMMENT = "CREATE_COMMENT";
export const UPDATE_COMMENT = "UPDATE_COMMENT";
export const RESET_COMMENTS = "RESET_COMMENTS";
export const DELETE_COMMENT = "DELETE_COMMENT";

export const createComment = (token, params, callback) => {
  return (dispatch) => {
    dispatch(openRequest(CREATE_COMMENT));
    authRequest(token, {
      url: `/posts/${params.postId}/comments`,
      method: "POST",
      data: {
        parent_id: params.parentId,
        content: params.content,
        raw_content: params.raw_content,
        template_id: params.template_id,
      },
    })
      .then((res) => {
        dispatch(closeRequest(CREATE_COMMENT));
        dispatch({ type: CREATE_COMMENT, comment: res.data.comment });
        callback(res.data.comment);
      })
      .catch((err) => {
        dispatch(closeRequest(CREATE_COMMENT));
        dispatch(showAppMessage(err.message, "error"));
      });
  };
};

export const updateComment = (token, params, callback) => {
  return (dispatch) => {
    dispatch(openRequest(UPDATE_COMMENT));
    authRequest(token, {
      url: `/posts/${params.postId}/comments/${params.id}`,
      method: "PATCH",
      data: {
        content: params.content,
        raw_content: params.raw_content,
        template_id: params.template_id,
      },
    })
      .then((res) => {
        dispatch(closeRequest(UPDATE_COMMENT));
        dispatch({ type: UPDATE_COMMENT, comment: res.data.comment });
        callback(res.data.comment);
      })
      .catch((err) => {
        dispatch(closeRequest(UPDATE_COMMENT));
        dispatch(showAppMessage(err.message, "error"));
      });
  };
};

export const deleteComment = (token, comment, data = {}) => {
  return (dispatch) => {
    authRequest(token, {
      url: `/posts/${comment.post_id}/comments/${comment.id}`,
      method: "DELETE",
      data: data,
    })
      .then((res) => {
        dispatch({
          type: DELETE_COMMENT,
          comment: comment,
          deletedComment: res.data.comment,
        });
        dispatch(showAppMessage("评论删除成功", "success"));
      })
      .catch((err) => {
        dispatch(showAppMessage(err.message, "error"));
      });
  };
};

export const resetComments = () => {
  return {
    type: RESET_COMMENTS,
  };
};

export const GET_POST_COMMENTS = "GET_POST_COMMENTS";
export const SET_POST_COMMENTS = "SET_POST_COMMENTS";
export const getPostComments = (postId, params) => {
  return (dispatch) => {
    dispatch(openRequest(GET_POST_COMMENTS));
    request({
      url: `/posts/${postId}/comments`,
      method: "GET",
      params: {
        page: params.page,
        sort: params.sort,
      },
    })
      .then((res) => {
        dispatch(closeRequest(GET_POST_COMMENTS));
        //reset commentList is empty when page 1
        if (params.page == 1) {
          dispatch({ type: RESET_COMMENTS });
        }
        dispatch({ type: SET_POST_COMMENTS, list: res.data });
        const ids = [];
        _.each(res.data.comments, (comment) => {
          ids.push(comment.id);
          ids.push(..._.map(comment.replies, "id"));
        });
        dispatch(fireEvent(GET_POST_COMMENTS, ids));
      })
      .catch((err) => {
        dispatch(closeRequest(GET_POST_COMMENTS));
        dispatch(showAppMessage(err.message, "error"));
      });
  };
};

/**
 * 增加评论ssr接口
 * @param postId
 * @param params
 */
export const fetchPostComments = (postId, params) => {
  return request({
    url: `/posts/${postId}/comments`,
    method: "GET",
    params: {
      page: params.page,
      sort: params.sort,
    },
  }).then((res) => res.data);
};

/**
 * Check flags
 */
export const CHECK_COMMENT_FLAGS = "CHECK_COMMENT_FLAGS";
export const checkCommentFlags = (token, flags, ids) => {
  return (dispatch) => {
    return authRequest(token, {
      url: "/comments/check",
      method: "POST",
      data: { flags, ids },
    })
      .then((res) => {
        dispatch({ type: CHECK_COMMENT_FLAGS, flags: res.data });
      })
      .catch((err) => {
        dispatch(showAppMessage(err.message));
      });
  };
};

/**
 * Votes
 */
export const VOTE_COMMENT = "VOTE_COMMENT";
export const UNVOTE_COMMENT = "UNVOTE_COMMENT";
export const voteComment = (token, id) => {
  return (dispatch) => {
    authRequest(token, {
      url: `/comments/${id}/vote`,
      method: "POST",
    })
      .then((res) => {
        dispatch({ type: VOTE_COMMENT, id });
        dispatch(fireEvent(VOTE_COMMENT, id));
      })
      .catch((err) => {
        dispatch(showAppMessage(err.message, "error"));
      });
  };
};
export const unvoteComment = (token, id) => {
  return (dispatch) => {
    authRequest(token, {
      url: `/comments/${id}/vote`,
      method: "DELETE",
    })
      .then((res) => {
        dispatch({ type: UNVOTE_COMMENT, id });
        dispatch(fireEvent(UNVOTE_COMMENT, id));
      })
      .catch((err) => {
        dispatch(showAppMessage(err.message, "error"));
      });
  };
};

/**
 * Upvotes / Downvotes
 */
export const CREATE_COMMENT_UPVOTE = "CREATE_COMMENT_UPVOTE";
export const DELETE_COMMENT_UPVOTE = "DELETE_COMMENT_UPVOTE";
export const CREATE_COMMENT_DOWNVOTE = "CREATE_COMMENT_DOWNVOTE";
export const DELETE_COMMENT_DOWNVOTE = "DELETE_COMMENT_DOWNVOTE";

export const createCommentUpvote = (token, id, callback) => {
  return (dispatch) => {
    authRequest(token, {
      url: `/comments/${id}/upvote`,
      method: "POST",
    })
      .then((res) => {
        dispatch({ type: CREATE_COMMENT_UPVOTE, id });
        callback && callback();
      })
      .catch((err) => {
        dispatch(showAppMessage(err.message, "error"));
      });
  };
};

export const deleteCommentUpvote = (token, id, callback) => {
  return (dispatch) => {
    authRequest(token, {
      url: `/comments/${id}/upvote`,
      method: "DELETE",
    })
      .then((res) => {
        dispatch({ type: DELETE_COMMENT_UPVOTE, id });
        callback && callback();
      })
      .catch((err) => {
        dispatch(showAppMessage(err.message, "error"));
      });
  };
};

export const createCommentDownvote = (token, id, callback) => {
  return (dispatch) => {
    authRequest(token, {
      url: `/comments/${id}/downvote`,
      method: "POST",
    })
      .then((res) => {
        dispatch({ type: CREATE_COMMENT_DOWNVOTE, id });
        callback && callback();
      })
      .catch((err) => {
        dispatch(showAppMessage(err.message, "error"));
      });
  };
};

export const deleteCommentDownvote = (token, id, callback) => {
  return (dispatch) => {
    authRequest(token, {
      url: `/comments/${id}/downvote`,
      method: "DELETE",
    })
      .then((res) => {
        dispatch({ type: DELETE_COMMENT_DOWNVOTE, id });
        callback && callback();
      })
      .catch((err) => {
        dispatch(showAppMessage(err.message, "error"));
      });
  };
};

/**
 * Charges
 */
export const CHARGE_COMMENT_SUCCESS = "CHARGE_COMMENT_SUCCESS";

// 充电成功后的状态回填：优先用响应里的 comment；
// 响应缺失时用本地数据构造（同一用户对同一评论只能充一次，可直接累加）。
export const createCommentCharge = (token, comment, ele, callback) => {
  return (dispatch, getState) => {
    const user = _.get(getState(), "user.user");
    const userEle = (user && user.ele) || 0;
    authRequest(token, {
      url: `/comments/${comment.id}/charges`,
      method: "POST",
      data: { ele },
    })
      .then((res) => {
        const updated = res.data && res.data.comment;
        if (!updated) {
          // 同一用户对同一评论只能充一次，本地累加即可得到准确的回填数据
          console.warn("comment charge response missing comment, fallback to local patch");
        }
        const charges = (comment.charges || []).filter(
          (c) => !user || !c.user || c.user.id !== user.id
        );
        const patch = updated || {
          ...comment,
          charges_count: (comment.charges_count || 0) + 1,
          charges_ele: (comment.charges_ele || 0) + ele,
          charges: [{ user, ele, created_at: new Date().toISOString() }, ...charges].slice(0, 3),
        };
        dispatch(showAppMessage(`充电成功, 电量剩余${userEle - ele}`, "success"));
        dispatch({ type: CHARGE_COMMENT_SUCCESS, comment: patch });
        callback && callback(null, patch);
      })
      .catch((err) => {
        dispatch(showAppMessage(err.message, "error"));
        callback && callback(err);
      });
  };
};

/**
 * Comment charges list（供弹窗本地消费，不走 redux）
 */
export const getCommentChargeList = (token, id, params) => {
  const config = {
    url: `/comments/${id}/charges`,
    params: {
      page: params.page,
      per_page: params.per_page,
    },
  };
  return (token ? authRequest(token, config) : request(config)).then(
    (res) => res.data
  );
};
